
export default {
    SET_MAP_LAYER: function (state, layer) {
        state.mapLayers = layer;
    },

    SET_VIRTUAL_STATION: function (state, vws) {
        state.newVirtualStationLatLon = vws;
    },

    SET_WFS_STATION: function (state, layer) {
        state.wfsLayers = [];
        state.wfsLayers.push(layer);
    },

    SET_MAP_TYPE: function (state, type) {
        state.mapType = type;
    }
}
